import React, { useEffect, useState } from 'react';
import axios from 'axios';
import cn from 'classnames';
import { useForm } from 'react-hook-form';
import * as PropTypes from 'prop-types';
/**/
import { selector_auth } from '../../reducer/auth';
import { useSelector } from 'react-redux';
import endpoints from '../../define/endpoints';
import { ModalResponse } from '../modals';
import ModalDrawer from '../modals/ModalDrawer';
import { useUUID } from '../../hooks/useUUID';
import { useMatchesMinWidth } from '../../hooks/useMatchesMinWidth';
import { Input } from '../Input';
import { RadioList } from '../modals/RadioList';
import InputPhone from '../InputPhone';
import Typography, {
  TypographyStates,
  TypographyVariants,
  TypographyWeights,
} from '../../ui-components/Typography/Typography';
import { TRANSLATIONS } from '../../../translations';
import { BREAKPOINTS } from '../../../constants';
import Button, {
  ButtonSizes,
  ButtonStyles,
  ButtonWidths,
} from '../Button/Button';
import BetaIcon, { IconColors, IconSizes } from '../Icons/Icon';

const SUCCESS_ICON = 'circleCheck';
const FAIL_ICON = 'warning';

const _FIRST_NAME = 'name';
const _EMAIL = 'email';
const _PHONE = 'phone';
const _ORDER_ID = 'id_order';
const _PRIVACY_AND_TERMS = 'privacy_and_condition_terms';
const _MARKETING_CONSENT = 'marketing_consent';
const _PROFILING_CONSENT = 'profiling_consent';

const XmasContestForm = ({ hubspotFormId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [isAlreadySubmitted, setIsAlreadySubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const checkboxID = useUUID();
  const checkboxID2 = useUUID();
  const checkboxID3 = useUUID();
  const { register, handleSubmit, errors, setValue } = useForm({
    reValidateMode: 'onChange',
  });

  const isDeviceSmallerThanMblLandscape = !useMatchesMinWidth(
    BREAKPOINTS.MBL_LANDSCAPE
  );

  return (
    <>
      <ModalDrawer
        content={
          <div className="pl-m pr-m pt-xl pb-xl w-100% text-center">
            <div className="d-flex flex-column items-center pb-2xs gap-xs">
              <BetaIcon
                name={(isSuccess || isAlreadySubmitted) ? SUCCESS_ICON : FAIL_ICON}
                size={IconSizes[64]}
              />
            </div>
            <div className="d-flex text-center align-center">
              {isSuccess ?
                <Typography variant={TypographyVariants.p2}>
                  <strong>Grazie per aver partecipato!</strong><br />
                  L'estrazione si terrà entro il 31 gennaio 2026. In caso di vincita, ti contatteremo noi. Continua ad acquistare i tuoi regali di Natale su Freedome per avere più opportunità di vincere!
                </Typography> :
                isAlreadySubmitted ?
                  <Typography variant={TypographyVariants.p2}>
                    <strong>Non preoccuparti!</strong><br />
                    La tua iscrizione al concorso con questo ID ordine è già andata a buon fine. Se hai effettuato un nuovo acquisto, puoi inserire il relativo ID Ordine.
                  </Typography> :
                  <Typography variant={TypographyVariants.p2} dangerouslySetInnerHTML={{ __html: errorMessage }}>
                  </Typography>}
            </div>
          </div>
        }
        modalCustomWidth={640}
        title={isSuccess ? 'Invio con successo' : isAlreadySubmitted ? 'ID ordine già inserito' : 'Errore richiesta'}
        isOpen={isModalOpen}
        setIsOpen={setIsModalOpen}
        isDeviceSmallerThanTablet={isDeviceSmallerThanMblLandscape}
        handleBeforeClose={() => setIsModalOpen(false)}
        footer={
          <div className="d-flex justify-center gap-m pb-m pl-xl pr-xl">
            <div style={{ minWidth: '170px' }}>
              <Button
                size={ButtonSizes.s}
                width={ButtonWidths.isFull}
                style={ButtonStyles.empty}
                label={isSuccess ? TRANSLATIONS.CLOSE : isAlreadySubmitted ? 'Registra un altro ordine' : TRANSLATIONS.RETRY_NOW}
                onClick={() => setIsModalOpen(false)}
              />
            </div>
            {isSuccess && <div style={{ minWidth: '170px' }}>
              <a href="/cerca-attivita-esperienze">
                <Button
                  size={ButtonSizes.s}
                  width={ButtonWidths.isFull}
                  style={ButtonStyles.primary}
                  label={'Esplora catalogo'}
                />
              </a>
            </div>}
          </div>
        }
      />

      <div className="mt-m mb-m">
        <Typography
          variant={TypographyVariants.h6}
          weight={TypographyWeights['semi-bold']}
        >
          Compila il form per partecipare
        </Typography>
      </div>
      <form
        data-gtm-item="XmasContestForm"
        data-gtm-detail="contact-form-page"
        onSubmit={handleSubmit(async (data) => {
          try {
            const response = await axios({
              method: 'post',
              url: `${endpoints.core}/form-requests`,
              data: {
                name: data[_FIRST_NAME],
                email: data[_EMAIL],
                phone: data[_PHONE],
                id_order: data[_ORDER_ID],
                hubspot_form_id: hubspotFormId,
                privacy: data[_PRIVACY_AND_TERMS],
                marketing_consent: data[_MARKETING_CONSENT] || false,
                profiling_consent: data[_PROFILING_CONSENT] || false,
              },
            });

            // Check if the response indicates success
            if (response.data && response.data.success) {
              setIsSuccess(true);
              setIsAlreadySubmitted(false);
              // If the axios call is successful, push the event to dataLayer
              dataLayer.push({ event: 'xmasFormSubmitted' });
            } else {
              // Handle case where API returns 200 but success: false
              setIsSuccess(false);

              // Check for error messages in the response
              if (response.data && response.data.errors && response.data.errors.message) {
                const errorMessages = response.data.errors.message;

                if (errorMessages && errorMessages.length > 0) {
                  const firstErrorMessage = errorMessages[0];

                  if (firstErrorMessage.includes('already submitted')) {
                    setIsAlreadySubmitted(true);
                  } else if (firstErrorMessage.includes('Invalid order ID') /*|| firstErrorMessage.includes('email does not match')*/) {
                    setIsAlreadySubmitted(false);
                    setErrorMessage('<strong>ID ordine o numero voucher non valido</strong><br/>ID ordine o numero voucher validi solo per acquisti effettuati dal 4 al 25 dicembre 2025. Puoi trovarli nell\'email di conferma della tua prenotazione o dell\'acquisto del voucher.');
                  } else {
                    setIsAlreadySubmitted(false);
                    setErrorMessage('<strong>Purtroppo si è verificato un errore inaspettato</strong><br/>Ti invitiamo a riprovare più tardi.');
                  }
                } else {
                  setIsAlreadySubmitted(false);
                  setErrorMessage('<strong>Purtroppo si è verificato un errore inaspettato</strong><br/>Ti invitiamo a riprovare più tardi.');
                }
              } else {
                setIsAlreadySubmitted(false);
                setErrorMessage('<strong>Purtroppo si è verificato un errore inaspettato</strong><br/>Ti invitiamo a riprovare più tardi.');
              }
            }
          } catch (error) {
            setIsSuccess(false);
            // console.error('Error submitting form:', error);

            if (error.response && error.response.data && error.response.data.errors) {
              const errorMessages = error.response.data.errors.message;

              if (errorMessages && errorMessages.length > 0) {
                const firstErrorMessage = errorMessages[0];

                if (firstErrorMessage.includes('already submitted')) {
                  setIsAlreadySubmitted(true);
                } else if (firstErrorMessage.includes('Invalid order ID') || firstErrorMessage.includes('email does not match')) {
                  setIsAlreadySubmitted(false);
                  setErrorMessage('<strong>ID ordine o numero voucher non valido</strong><br/>ID ordine o numero voucher validi solo per acquisti effettuati dal 4 al 25 dicembre 2025. Puoi trovarli nell\'email di conferma della tua prenotazione o dell\'acquisto del voucher.');
                } else {
                  setIsAlreadySubmitted(false);
                  setErrorMessage('<strong>Purtroppo si è verificato un errore inaspettato</strong><br/>Ti invitiamo a riprovare più tardi.');
                }
              } else {
                setIsAlreadySubmitted(false);
                setErrorMessage('<strong>Purtroppo si è verificato un errore inaspettato</strong><br/>Ti invitiamo a riprovare più tardi.');
              }
            } else {
              setIsAlreadySubmitted(false);
              setErrorMessage('<strong>Purtroppo si è verificato un errore inaspettato</strong><br/>Ti invitiamo a riprovare più tardi.');
            }
          } finally {
            setIsModalOpen(true);
            const values = [];
            values.push({ [_ORDER_ID]: '' });
            setValue(values);
          }
        })}
      >
        <div className="d-flex flex-column gap-3xs" style={{ gap: '20px' }}>
          <Input
            errored={!!errors[_FIRST_NAME]}
            shadowed
            label={app_main_wpml.contact_name + '*'}
            name={_FIRST_NAME}
            setRef={register({ required: true, max: 1000 })}
            data-gtm-item="xmas-form"
            data-gtm-detail="name"
          />
          <Input
            errored={!!errors[_EMAIL]}
            shadowed
            label={'E-mail*'}
            name={_EMAIL}
            setRef={register({
              required: true,
              max: 1000,
              pattern: /^\S+@\S+$/i,
            })}
            data-gtm-item="xmas-form"
            data-gtm-detail="email"
          />
          <Input
            errored={!!errors[_PHONE]}
            shadowed
            label={app_main_wpml.phone + '*'}
            name={_PHONE}
            setRef={register({
              required: true,
              pattern: /^\d+$/,
            })}
            data-gtm-item="xmas-form"
            data-gtm-detail="phone"
          />
          <Input
            errored={!!errors[_ORDER_ID]}
            shadowed
            type="number"
            label={'ID ordine o ID voucher*'}
            name={_ORDER_ID}
            setRef={register({
              required: true,
              min: 100000,
              max: 999999,
              pattern: /^\d{6}$/
            })}
            data-gtm-item="xmas-form"
            data-gtm-detail="message"
          />
        </div>

        <div className="mt-3xs mb-m">
          <Typography
            variant={TypographyVariants.p3}
            state={TypographyStates['neutral-light']}
          >
            Puoi trovare l’ID ordine o l’ID del voucher nell’email di conferma della tua prenotazione o di acquisto voucher.
          </Typography>
        </div>

        <div className="d-flex flex-column gap-3xs" style={{ gap: '12px' }}>
          <div
            className={cn('fake-checkbox', {
              'fake-checkbox--errored': !!errors[_PRIVACY_AND_TERMS],
            })}
          >
            <input
              className="fake-checkbox__input"
              type="checkbox"
              name={_PRIVACY_AND_TERMS}
              ref={register({ required: true })}
              id={checkboxID}
              data-gtm-item="contact-form"
              data-gtm-detail="privacy"
            />
            <label htmlFor={checkboxID} className="fake-checkbox__label">
              <span
                className="iconify inline"
                data-icon="mdi:check-bold"
              ></span>
            </label>
            <p className="fake-checkbox__text">
              Ho preso visione delle informazioni da fornire ex art. 13, GDPR e accetto il regolamento del concorso*
            </p>
          </div>

          <div className="fake-checkbox">
            <input
              className="fake-checkbox__input"
              type="checkbox"
              name={_MARKETING_CONSENT}
              ref={register({ required: false })}
              id={checkboxID2}
              data-gtm-item="contact-form"
              data-gtm-detail="marketing"
            />
            <label htmlFor={checkboxID2} className="fake-checkbox__label">
              <span
                className="iconify inline"
                data-icon="mdi:check-bold"
              ></span>
            </label>
            <p className="fake-checkbox__text">
              Acconsento al trattamento dei miei dati per fini promozionali
            </p>
          </div>

          <div className="fake-checkbox">
            <input
              className="fake-checkbox__input"
              type="checkbox"
              name={_PROFILING_CONSENT}
              ref={register({ required: false })}
              id={checkboxID3}
              data-gtm-item="contact-form"
              data-gtm-detail="profiling"
            />
            <label htmlFor={checkboxID3} className="fake-checkbox__label">
              <span
                className="iconify inline"
                data-icon="mdi:check-bold"
              ></span>
            </label>
            <p className="fake-checkbox__text">
              Acconsento al trattamento dei miei dati per contatti personalizzati ("profilazione")
            </p>
          </div>
        </div>
        <button
          className="beta-btn beta-btn--primary beta-btn--s beta-btn--full mt-xl mb-l font-bold"
          type="submit"
        >
          {app_main_wpml.contact_send}
        </button>
      </form>
    </>
  );
};

XmasContestForm.propTypes = {
  hubspotFormId: PropTypes.string,
};

XmasContestForm.defaultProps = {
  textAreaRows: 7,
};

export default XmasContestForm;
